<template>
  <gs-named-modal class="gs-refresh-controls"
    name="add-commission-advance-modal"
    :title="$t('frontend_groovesell_add_commision_advance')"
    bg-type="regular"
    @closed="onClose"
  >
    <div v-if="selectedAffiliate" class="flex gs-dialog-mobile-body">
      <div class="flex flex-col w-full px-4">
        <div class="mt-2">
          <!-- Amount Input -->
          <div class="w-full flex flex-row mb-6">
            <label class="w-1/3 mt-1 font-semibold text-grey-700">{{ $t('frontend_affiliate_index_amount') }}</label>
            <div class="w-2/3">
              <gd-currency-input v-model="commissionAdvance.amount" currency-code="USD" />
            </div>
          </div>

          <!-- Transaction ID Input -->
          <div class="w-full flex flex-row mb-6">
            <label class="w-1/3 mt-1 font-semibold text-grey-700">{{ $t('frontend_affiliate_index_transaction') }}</label>
            <text-input
              v-model="commissionAdvance.transactionId"
              :validator="$v.commissionAdvance.transactionId"
              :attribute="$t('frontend_affiliate_index_transaction_id')"
              class="w-2/3"
              :placeholder="$t('frontend_affiliate_index_transaction_id')"
            />
          </div>

          <!-- Comment Input -->
          <div class="w-full flex flex-row mb-6">
            <label class="w-1/3 mt-1 font-semibold text-grey-700">{{ $t('frontend_affiliate_index_comment') }}</label>
            <text-input
              v-model="commissionAdvance.comment"
              :validator="$v.commissionAdvance.comment"
              :attribute="$t('frontend_affiliate_index_comment')"
              class="w-2/3"
              :placeholder="$t('frontend_affiliate_index_comment')"
            />
          </div>

          <!-- Add Commission Advance Button -->
          <div class="flex flex-row w-full mb-6 justify-end">
            <gs-button class="mb-4" :disabled="isProcessingAdvance" :aria-busy="isProcessingAdvance" @click="addCommissionAdvance()">
              <span v-if="isProcessingAdvance" role="status"><span aria-hidden="true" class="inline-block animate-spin mr-2" style="width: 12px; height: 12px; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%;"></span>Recording…</span><span v-else>{{ $t('frontend_affiliate_index_add_commision_advance') }}</span>
            </gs-button>
          </div>
        </div>
      </div>
    </div>
  </gs-named-modal>
</template>

<script>
import { required, maxLength, decimal, minValue } from 'vuelidate/lib/validators';
import Swal from 'sweetalert2';
import AffiliatePayment from '@/models/AffiliatePayment';
import SecondTierAffiliate from '@/models/SecondTierAffiliate';

export default {
  props: {
    selectedAffiliate: {
      type: Object,
      default: null,
    },
    filtersModel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isProcessingAdvance: false,
      commissionAdvance: {
        amount: 0,
        comment: '',
        transactionId: '',
      },
    };
  },
  methods: {
    async addCommissionAdvance() {
      this.$v.commissionAdvance.$touch();
      if (this.$v.commissionAdvance.$invalid || this.isProcessingAdvance) return;
      this.isProcessingAdvance = true;
      let recorded = false;
      const dialog = Swal.mixin({ target: this.$el, keydownListenerCapture: true });
      try {

      this.$loader.start('addCommissionAdvance');
      const affiliatePayment = new AffiliatePayment({
        affiliate_id: this.selectedAffiliate.id,
        amount: this.commissionAdvance.amount,
        payment_gateway: 0,
        note: this.commissionAdvance.comment,
        transaction_id: this.commissionAdvance.transactionId,
        type: 6,
        funnel: this.filtersModel.selectedFunnel,
      });

      await affiliatePayment.save();
      recorded = true;
      await dialog.fire({ title: 'Commission advance recorded', icon: 'success', confirmButtonText: 'Done', allowOutsideClick: false });
      this.$root.$emit('modal-close', 'add-commission-advance-modal');
      
      const newSelectedAffiliate = await SecondTierAffiliate.params({
        funnels: this.filtersModel.selectedFunnel,
      }).$find(this.selectedAffiliate.id);
      this.$emit('updateSelectedAffiliate', newSelectedAffiliate);

      this.$emit('changedSearchOrFilter');
      } catch (error) {
        await dialog.fire(recorded ? 'Advance recorded; refresh failed' : 'Commission advance failed', recorded ? 'The advance was saved. Please reload; do not add it again.' : 'Check payment history before trying again.', 'error');
      } finally {
        this.isProcessingAdvance = false;
        this.$loader.end('addCommissionAdvance');
      }
    },
    onClose() {
      this.commissionAdvance = {
        amount: 0,
        comment: '',
        transactionId: '',
      };
    },
  },
  validations: {
    commissionAdvance: {
      amount: {
        required,
        decimal,
        minValue: minValue(1),
      },
      comment: {
        maxLength: maxLength(255),
      },
      transactionId: {
        maxLength: maxLength(255),
      },
    },
  },
};
</script>

<style scoped>
@media (max-width: 640px) {
  .gs-dialog-mobile-body { flex-wrap: wrap; min-width: 0; width: 100%; }
  .gs-dialog-mobile-body .flex-row { flex-wrap: wrap; }
  .gs-dialog-mobile-body .w-1\/4, .gs-dialog-mobile-body .w-1\/3, .gs-dialog-mobile-body .w-1\/2, .gs-dialog-mobile-body .w-2\/3, .gs-dialog-mobile-body .w-3\/4 { width: 100%; }
}
</style>
